// @ts-nocheck
import { createStyle } from '@gluestack-style/react';
import { BaseIconVariants } from './Icon';

export const SelectActionsheetIcon = createStyle({
  variants: BaseIconVariants,
  mr: '$2',
  color: '$backgroundLight500',
  _dark: {
    color: '$backgroundDark400',
  },
  props: {
    size: 'md',
  },
});
